import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const AddSquare = withDefaultIconProps({ height: 40, width: 40 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 40 40">
    <Path
      d="M33.94 0.47H6.06C2.98 0.47 0.47 2.98 0.47 6.06V33.94C0.47 37.02 2.98 39.53 6.06 39.53H33.94C37.02 39.53 39.53 37.02 39.53 33.94V6.06C39.53 2.98 37.02 0.47 33.94 0.47ZM11 21.53C10.16 21.53 9.47 20.84 9.47 20C9.47 19.16 10.16 18.47 11 18.47H18.47V11C18.47 10.16 19.16 9.47 20 9.47C20.84 9.47 21.53 10.16 21.53 11V18.47H29C29.84 18.47 30.53 19.16 30.53 20C30.53 20.84 29.84 21.53 29 21.53H21.53V29C21.53 29.84 20.84 30.53 20 30.53C19.16 30.53 18.47 29.84 18.47 29V21.53H11Z"
      fill={color}
    />
  </Svg>
));
